import { createRouter, createWebHistory } from "vue-router";

import AboutUs from "./pages/AboutUs.vue";
import AllMinerals from "./pages/minerals/AllMinerals.vue";
import HomePage from "./pages/HomePage.vue";
import NotFound from "./pages/NotFound.vue";

import RocksHome from "./pages/rocks/RocksHome.vue";
import AllRocks from "./pages/rocks/AllRocks.vue";
import OneRock from "./pages/rocks/OneRock.vue";
import MineralsHome from "./pages/minerals/MineralsHome.vue";
import OneMineral from "./pages/minerals/OneMineral.vue";
import MineralFilter from "./pages/minerals/MineralFilter.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: HomePage },
    {
      path: "/minerals",
      component: MineralsHome,
      children: [
        { path: "", component: AllMinerals },
        { path: ":mineralId", component: OneMineral },
        { path: "filter", component: MineralFilter },
      ],
    },

    {
      path: "/rocks",
      component: RocksHome,
      children: [
        { path: "", component: AllRocks },
        { path: ":rockId", component: OneRock },
      ],
    },
    // REGULAR PAGES
    { path: "/about", component: AboutUs },
    { path: "/:notFound(.*)", component: NotFound },
  ],
});

export default router;
